import { render } from "./ViewAppVersions.vue?vue&type=template&id=4449ed03&scoped=true"
import script from "./ViewAppVersions.vue?vue&type=script&lang=js"
export * from "./ViewAppVersions.vue?vue&type=script&lang=js"

import "./ViewAppVersions.vue?vue&type=style&index=0&id=4449ed03&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4449ed03"]])

export default __exports__